import { useQuery } from "react-query";
import { populateObjectWithDefaults } from "../../utils/helpers";
import qs from "qs";
import api from "../../utils/api";

const defaultUseGetOptions = {
  params: {
    page: undefined,
    size: undefined,
    search_params: undefined,
    keep_related: undefined,
    values: undefined,
    exclude: undefined,
    order_by: undefined,
    select_related: undefined
  },
  enabled: true,
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  refetchOnMount: undefined,
  retry: true,
  retryCount: 2,
};
export default function useGet(url, options = defaultUseGetOptions) {
  populateObjectWithDefaults(options, defaultUseGetOptions);
  const {
    params,
    enabled,
    staleTime = 1000 * 60 * 5,
    refetchOnWindowFocus,
    refetchOnMount,
    retry,
    retryCount,
  } = options;
  for (let [key, val] of Object.entries(params)) {
    if (Array.isArray(val)) {
      params[key] = val.toString();
    } else if (val && typeof val == "object") {
      params[key] = JSON.stringify(val);
    }
  }

  const queryString = qs.stringify(params, { addQueryPrefix: true });
  return useQuery(
    [url, queryString],
    () => api.get(`${url}${queryString}`).then((res) => res.data),
    {
      staleTime,
      enabled,
      refetchOnWindowFocus,
      refetchOnMount,
      retry,
      failureCount: retry ? retryCount ?? 2 : undefined,
    }
  );
}
